import { Card, CardBody, Col } from "reactstrap";
import DisabledForm from "./DisabledForm";
import { BasicSliderData } from "../../../../data/bonusUi/RangSlider";
import { DisabledSliderTitle } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const Disabled = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={DisabledSliderTitle} span={BasicSliderData} />
        <CardBody>
          <DisabledForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Disabled;
